import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormLabel,
  Grid2,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as CloseIcon } from "Assets/Icons/Home/CloseIcon.svg";
import { addExperience, updateExperience } from "Slices/thunks";
import { useFormik } from "formik";
import * as yup from "yup";


const AddEditExperience = ({ open, setOpen, experience, setExperience }) => {
  const dispatch = useDispatch();
  const handleClose = () => {
    setOpen(false);
    resetForm();
  };

  // const [expData, setExpData] = useState({
  //   Company: null,
  //   JobTitle: null,
  //   ManageTeam: false,
  //   TeamSizeID: null,
  //   StartYearID: null,
  //   StartMonthID: null,
  //   EndYearID: null,
  //   EndMonthID: null,
  //   CurrentlyWork: false,
  //   Salary: "",
  // });

  const { Common, Translation } = useSelector((state) => ({
    Common: state.Common.common,
    Translation: state.Translation.translation?.Settings || {},
  }));

  const Schema = useMemo(() => {
    return yup.object({
      Company: yup.string().required(Translation?.FieldRequired || "This field is required."),
      JobTitle: yup.string().required(Translation?.FieldRequired || "This field is required."),
      ManageTeam: yup.string().required(Translation?.FieldRequired || "This field is required."),
      TeamSizeID: yup.string(),
      StartYearID: yup.string().required(Translation?.FieldRequired || "This field is required."),
      StartMonthID: yup.string().required(Translation?.FieldRequired || "This field is required."),
      // EndYearID: yup.string(),
      // EndMonthID: yup.string(),
      StartYear: yup.string(),
      StartMonth: yup.string(),
      // EndYear: yup.string(),
      // EndMonth: yup.string(),
      CurrentlyWork: yup.boolean().required(Translation?.FieldRequired || "This field is required."),
      Salary: yup.string().required(Translation?.FieldRequired || "This field is required.")
    });
  }, [Translation])

  const {
    dirty,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    resetForm,
    touched,
    setFieldValue,
  } = useFormik({
    initialValues: experience,
    enableReinitialize: true,
    onSubmit: (data) => {
      const experienceObj = {
        ID: experience.ID,
        Company: data.Company,
        JobTitle: data.JobTitle,
        ManageTeam: data.ManageTeam,
        TeamSizeID: data.TeamSizeID || null,
        StartYearID: data.StartYearID,
        StartMonthID: data.StartMonthID,
        EndYearID: data.EndYearID,
        EndMonthID: data.EndMonthID,
        StartYear: data.StartYear,
        StartMonth: data.StartMonth,
        EndYear: data.EndYear,
        EndMonth: data.EndMonth,
        CurrentlyWork: data.CurrentlyWork,
        Salary: data.Salary,
      }

      experience.ID ?
      dispatch(updateExperience(experienceObj)) :
      dispatch(addExperience(experienceObj))

      setExperience({});
      setOpen(false);
    },
    validationSchema: Schema,
  });



  return (
    <Dialog
      fullWidth
      maxWidth={"sm"}
      open={Boolean(open)}
      onClose={() => handleClose()}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
      <DialogTitle>
        {" "}
        {Translation?.Experience}{" "}
        <IconButton onClick={() => handleClose()}>
          {" "}
          <PrimaryIcon
            icon={CloseIcon}
            color="white"
            height="14px"
            width="14px"
          />{" "}
        </IconButton>{" "}
      </DialogTitle>

        <DialogContent>
          <Grid2 display={"flex"} flexDirection={"column"} gap="16px">
            {/* <FormControl fullWidth>
              <FormLabel color="secondary" required label>
                {Translation?.Company}
              </FormLabel>
              <Autocomplete
                options={companyList}
                value={values?.company}
                onChange={(e, value) => setFieldValue("company", value)}
                autoHighlight
                getOptionLabel={(option) => option?.Value}
                clearIcon={false}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  return (
                    <Typography key={key} {...optionProps}>
                      {option?.Value}
                    </Typography>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    error={touched.company && errors.company}
                    helperText={
                      touched.company && errors.company && errors.company
                    }
                    name="company"
                    placeholder={Translation?.EnterCompanyName}
                    slotProps={{
                      htmlInput: {
                        ...params.inputProps,
                        autoComplete: "new-password",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
            <FormControl fullWidth>
              <FormLabel color="secondary" required label>
                {Translation?.JobTitleOrRole}
              </FormLabel>
              <Autocomplete
                options={rolesList}
                autoHighlight
                getOptionLabel={(option) => option?.Value}
                clearIcon={false}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  return (
                    <Typography key={key} {...optionProps}>
                      {option?.Value}
                    </Typography>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    error={touched.role && errors.role}
                    helperText={touched.role && errors.role && errors.role}
                    name="role"
                    placeholder={Translation?.SelectJobTitle}
                    slotProps={{
                      htmlInput: {
                        ...params.inputProps,
                        autoComplete: "new-password",
                      },
                    }}
                  />
                )}
              />
            </FormControl> */}
            <FormControl fullWidth>
              <FormLabel color="secondary" label>
                {Translation?.Company}
              </FormLabel>
              <TextField
                error={touched.Company && errors.Company}
                helperText={touched.Company && errors.Company && errors.Company}
                onChange={handleChange}
                onBlur={handleBlur}
                name="Company"
                size="small"
                value={values.Company}
                placeholder={Translation?.EnterCompanyName}
              />
            </FormControl>
            <FormControl fullWidth>
              <FormLabel color="secondary" label>
                {Translation?.JobTitleOrRole}
              </FormLabel>
              <TextField
                error={touched.JobTitle && errors.JobTitle}
                helperText={touched.JobTitle && errors.JobTitle && errors.JobTitle}
                onChange={handleChange}
                onBlur={handleBlur}
                name="JobTitle"
                size="small"
                value={values.JobTitle}
                placeholder={Translation?.EnterJobTitle}
              />
            </FormControl>
            <FormControl
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <FormLabel color="secondary" label>
                {Translation?.ManageTeam}
              </FormLabel>
              <Checkbox
                onBlur={handleBlur}
                onChange={(e) => setFieldValue("ManageTeam", e.target.checked)}
                checked={values?.ManageTeam}
                size="small"
              />
            </FormControl>
            {values?.ManageTeam && (
              <FormControl fullWidth>
                <FormLabel color="secondary" required label>
                  {Translation?.TeamSize}
                </FormLabel>
                <Autocomplete
                  options={(Common?.TeamSize || [])}
                  autoHighlight
                  getOptionLabel={(option) => option.Value}
                  clearIcon={false}
                  onBlur={handleBlur}
                  value={(Common?.TeamSize || []).find((item) => item.ID == values.TeamSizeID)}
                  onChange={(value, newVal) => setFieldValue('SkillID', newVal?.ID)}
                  noOptionsText={<Typography>{Translation?.NoResultsFound}</Typography>}
                  renderOption={(props, option) => {
                    const { key, ...optionProps } = props;
                    return (
                      <Typography key={key} {...optionProps}>
                        {option.Value}
                      </Typography>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      name="TeamSizeID"
                      error={touched.TeamSizeID && errors.TeamSizeID}
                      helperText={touched.TeamSizeID && errors.TeamSizeID && errors.TeamSizeID}
                      placeholder={Translation?.SelectTeamSize}
                      slotProps={{
                        htmlInput: {
                          ...params.inputProps,
                          autoComplete: "new-password",
                        },
                      }}
                    />
                  )}
                />
              </FormControl>
            )}
            <Box display={"flex"} alignItems={"center"} gap={"20px"}>
              <FormControl fullWidth>
                <FormLabel color="secondary" required label>
                  {Translation?.StartDate}
                </FormLabel>
                <Box display={"flex"} alignItems={"center"} gap={"16px"}>
                  <Autocomplete
                    options={(Common?.Months || [])}
                    fullWidth
                    autoHighlight
                    getOptionLabel={(option) => option.Value}
                    clearIcon={false}
                    value={(Common?.Months || []).find((item) => item.ID == values.StartMonthID)}
                    onBlur={handleBlur}
                    onChange={(value, newVal) => {
                      setFieldValue('StartMonthID', newVal?.ID)
                      setFieldValue('StartMonth', newVal?.Value2)
                    }}
                    noOptionsText={<Typography>{Translation?.NoResultsFound}</Typography>}
                    renderOption={(props, option) => {
                      const { key, ...optionProps } = props;
                      return (
                        <Typography key={key} {...optionProps}>
                          {option.Value}
                        </Typography>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        name="StartMonthID"
                        error={touched.StartMonthID && errors.StartMonthID}
                        helperText={
                          touched.StartMonthID &&
                          errors.StartMonthID &&
                          errors.StartMonthID
                        }
                        placeholder={Translation?.Month}
                        slotProps={{
                          htmlInput: {
                            ...params.inputProps,
                            autoComplete: "new-password",
                          },
                        }}
                      />
                    )}
                  />
                  <Autocomplete
                    options={(Common?.GraduationYear || [])}
                    autoHighlight
                    getOptionLabel={(option) => option.Value}
                    fullWidth
                    clearIcon={false}
                    value={(Common?.GraduationYear || []).find((item) => item.ID == values.StartYearID)}
                    onBlur={handleBlur}
                    onChange={(value, newVal) => {
                      setFieldValue('StartYearID', newVal?.ID)
                      setFieldValue('StartYear', newVal?.Value)
                    }}
                    noOptionsText={<Typography>{Translation?.NoResultsFound}</Typography>}
                    renderOption={(props, option) => {
                      const { key, ...optionProps } = props;
                      return (
                        <Typography key={key} {...optionProps}>
                          {option.Value}
                        </Typography>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        name="StartYearID"
                        error={touched.StartYearID && errors.StartYearID}
                        helperText={
                          touched.StartYearID &&
                          errors.StartYearID &&
                          errors.StartYearID
                        }
                        placeholder={Translation?.Year}
                        slotProps={{
                          htmlInput: {
                            ...params.inputProps,
                            autoComplete: "new-password",
                          },
                        }}
                      />
                    )}
                  />
                </Box>
              </FormControl>
              {!values?.CurrentlyWork && (
                <FormControl fullWidth>
                  <FormLabel color="secondary" required label>
                    {Translation?.EndDate}
                  </FormLabel>
                  <Box display={"flex"} alignItems={"center"} gap={"16px"}>
                    <Autocomplete
                      options={(Common?.Months || [])}
                      autoHighlight
                      fullWidth
                      getOptionLabel={(option) => option.Value}
                      clearIcon={false}
                      value={(Common?.Months || []).find((item) => item.ID == values.EndMonthID)}
                      onBlur={handleBlur}
                      onChange={(value, newVal) => {
                        setFieldValue('EndMonthID', newVal?.ID)
                        setFieldValue('EndMonth', newVal?.Value2)
                      }}
                      noOptionsText={<Typography>{Translation?.NoResultsFound}</Typography>}
                      renderOption={(props, option) => {
                        const { key, ...optionProps } = props;
                        return (
                          <Typography key={key} {...optionProps}>
                            {option.Value}
                          </Typography>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          name="EndMonthID"
                          error={touched.EndMonthID && errors.EndMonthID}
                          helperText={
                            touched.EndMonthID &&
                            errors.EndMonthID &&
                            errors.EndMonthID
                          }
                          placeholder={"Month"}
                          slotProps={{
                            htmlInput: {
                              ...params.inputProps,
                              autoComplete: "new-password",
                            },
                          }}
                        />
                      )}
                    />
                    <Autocomplete
                      options={(Common?.GraduationYear || [])}
                      autoHighlight
                      getOptionLabel={(option) => option.Value}
                      fullWidth
                      clearIcon={false}
                      value={(Common?.GraduationYear || []).find((item) => item.ID == values.EndYearID)}
                      onBlur={handleBlur}
                      onChange={(value, newVal) => {
                        setFieldValue('EndYearID', newVal?.ID)
                        setFieldValue('EndYear', newVal?.Value)
                      }}
                      noOptionsText={<Typography>{Translation?.NoResultsFound}</Typography>}
                      renderOption={(props, option) => {
                        const { key, ...optionProps } = props;
                        return (
                          <Typography key={key} {...optionProps}>
                            {option.Value}
                          </Typography>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          name="EndYearID"
                          error={touched.EndYearID && errors.EndYearID}
                          helperText={
                            touched.EndYearID &&
                            errors.EndYearID &&
                            errors.EndYearID
                          }
                          placeholder={"Year"}
                          slotProps={{
                            htmlInput: {
                              ...params.inputProps,
                              autoComplete: "new-password",
                            },
                          }}
                        />
                      )}
                    />
                  </Box>
                </FormControl>
              )}
            </Box>
            <FormControl
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <FormLabel color="secondary" label>
                {Translation?.CurrentlyWorkHere}
              </FormLabel>
              <Checkbox
                onBlur={handleBlur}
                onChange={(e) => {
                  setFieldValue("CurrentlyWork", e.target.checked)
                  setFieldValue("EndYearID", null)
                  setFieldValue("EndYear", null)
                  setFieldValue("EndMonthID", null)
                  setFieldValue("EndMonth", null)
                }}
                checked={values?.CurrentlyWork}
                name="CurrentlyWork"
                size="small"
              />
            </FormControl>
            <FormControl fullWidth>
              <FormLabel color="secondary" label>
                {Translation?.AnnualSalary}
              </FormLabel>
              <TextField
                error={touched.Salary && errors.Salary}
                helperText={touched.Salary && errors.Salary && errors.Salary}
                onChange={handleChange}
                onBlur={handleBlur}
                name="Salary"
                value={values.Salary}
                size="small"
                placeholder=""
                onKeyDown={(e) => {
                  const allowedKeys = [
                    'Backspace',
                    'ArrowLeft',
                    'ArrowRight',
                    'Delete',
                    'Tab'
                  ];

                  if (
                    !/[0-9]/.test(e.key) && 
                    !allowedKeys.includes(e.key)
                  ) {
                    e.preventDefault();
                  }
                }}
                onPaste={(e) => {
                  const pasted = e.clipboardData.getData('Text');
                  if (!/^\d+$/.test(pasted)) {
                    e.preventDefault();
                  }
                }}
              />
            </FormControl>
          </Grid2>
        </DialogContent>
        <DialogActions primary>
          <Button
            onClick={() => handleClose()}
            variant="outlined"
            color="secondary"
          >
            {Translation?.Cancel}
          </Button>
          <Button type="submit" variant="contained">
            {Translation?.SaveChanges}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default React.memo(AddEditExperience);
